type HeaderTheme = {
  topbarBg: string;
  titleGradient: string;
  text: string;
  softBorder?: string;
  chipBg?: string;
  gold?: string;
};

type ThemedPageHeaderProps = {
  title: string;
  onBack: () => void;
  theme: HeaderTheme;
  action?: string;
  onAction?: () => void;
};

export function ThemedPageHeader({ title, onBack, theme, action, onAction }: ThemedPageHeaderProps) {
  return (
    <header className="fixed left-1/2 top-0 z-50 flex h-[56px] w-full max-w-[430px] -translate-x-1/2 items-center justify-center px-5" style={{ background: theme.topbarBg }}>
      <button
        type="button"
        aria-label={title}
        onClick={onBack}
        className="absolute left-5 top-1/2 flex size-[30px] -translate-y-1/2 items-center justify-center"
        style={{ color: theme.text }}
      >
        <BackIcon />
      </button>
      <span className="bg-clip-text text-base font-semibold leading-snug text-transparent" style={{ backgroundImage: theme.titleGradient }}>
        {title}
      </span>
      {action && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="absolute right-5 top-1/2 h-8 -translate-y-1/2 rounded-lg border px-3 text-xs font-semibold"
          style={{
            borderColor: theme.softBorder ?? 'rgba(245, 236, 99, 0.25)',
            background: theme.chipBg ?? 'rgba(245, 236, 99, 0.08)',
            color: theme.gold ?? theme.text,
          }}
        >
          {action}
        </button>
      )}
    </header>
  );
}

function BackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path d="M11.9625 7.4125L4.375 15L11.9625 22.5875" stroke="currentColor" strokeWidth="1.875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M25.625 15H4.58752" stroke="currentColor" strokeWidth="1.875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
